import { render, staticRenderFns } from "./ProjRate.vue?vue&type=template&id=0c3a8744"
import script from "./ProjRate.vue?vue&type=script&lang=js"
export * from "./ProjRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports